import styled from 'styled-components';
import css from '@styled-system/css';

export const StyledSpan = styled.span`
  display: block;
  ${css({
    pt: 'large',
  })}
`;
